import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, RadioGroup, FormControlLabel, Radio, TextField } from '@mui/material';
import BaseModal from 'components/BaseModal';
import { CartAbandonmentDetailEnum } from 'enums';

const Props = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onActionClick: PropTypes.func.isRequired,
};

export default function NotReadyModal({ open, onClose, onActionClick }) {
  const [detail, setDetail] = useState('');
  const [description, setDescription] = useState('');

  function handleActionClick() {
    onActionClick({ detail, description });

    setDetail('');
    setDescription('');
  }

  return (
    <BaseModal
      size="sm"
      open={open}
      title={
        <b>
          Let us know why are you not <br /> ready to subscribe
        </b>
      }
      content={
        <Box px={2}>
          <Box display="flex" justifyContent="center" mb={4}>
            <RadioGroup value={detail} onChange={({ target: { value } }) => setDetail(value)}>
              <FormControlLabel
                label="I'm comparing prices"
                value={CartAbandonmentDetailEnum.COMPARING_PRICES}
                control={<Radio color="secondary" />}
              />
              <FormControlLabel
                label="I'm still getting to know the platform"
                value={CartAbandonmentDetailEnum.KNOWING_PLATFORM}
                control={<Radio color="secondary" />}
              />
              <FormControlLabel
                label="The platform doesn't meet my current needs"
                value={CartAbandonmentDetailEnum.NOT_MEET_NEEDS}
                control={<Radio color="secondary" />}
              />
              <FormControlLabel
                label="I'm here by mistake"
                value={CartAbandonmentDetailEnum.MISTAKE_ACCESS}
                control={<Radio color="secondary" />}
              />
              <FormControlLabel
                label="Others"
                value={CartAbandonmentDetailEnum.OTHER}
                control={<Radio color="secondary" />}
              />
            </RadioGroup>
          </Box>

          <TextField
            fullWidth={true}
            multiline={true}
            variant="outlined"
            inputProps={{ minRows: 2 }}
            label="Tell us a little more about the problem."
            value={description}
            onChange={({ target: { value } }) => setDescription(value)}
          />
        </Box>
      }
      actionText="Share with us"
      disableActionButton={!detail}
      cancelButton={false}
      onActionClick={handleActionClick}
      onClose={onClose}
    />
  );
}

NotReadyModal.propTypes = Props;
